module.exports = __webpack_public_path__ + "media/images/landing/browser_planning.en-86d2610d06cfaf7c73765baec09b526d.png";